import { FC } from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

interface AssistantOrbProps {
  className?: string;
}

export const AssistantOrb: FC<AssistantOrbProps> = ({ className }) => (
  <span aria-hidden className={cn('ai-orb inline-block size-3', className)} />
);
